import { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { useAssetsByWorkspaceQuery } from 'queries/assets/queries';
import { dayjs } from 'lib/dayjs';
import { EDateFormats } from 'utils';
import { findByIdRecursive } from 'utils/Trail';

export interface TabConfig {
  key: string;
  url: string;
  label: string;
  disabled?: boolean;
}
export const buildDateRange = (period: string | number) => ({
  startDate: dayjs().subtract(+period, 'days').format(EDateFormats.API_DATE_FORMAT),
  endDate: dayjs().format(EDateFormats.API_DATE_FORMAT),
});

export const useAssetData = () => {
  const { assetId } = useParams();
  const { data, isFetching, error } = useAssetsByWorkspaceQuery();

  const workspaceAssetRoot = data && data?.items.length > 0 ? data?.items[0] : undefined;

  const currentAsset = useMemo(
    () =>
      !data?.items
        ? undefined
        : findByIdRecursive(data?.items, assetId ?? workspaceAssetRoot?.id)?.item,
    [assetId, data],
  );

  return {
    asset: {
      ...currentAsset,
      id: assetId ?? workspaceAssetRoot?.id,
      has_subitems: (currentAsset?.children?.length ?? 0) > 0,
    },
    assetTree: data?.items ?? [],
    isLoading: isFetching,
    workspaceAssetRoot: {
      ...workspaceAssetRoot,
      has_subitems: (workspaceAssetRoot?.children?.length ?? 0) > 0,
    },
    error,
  };
};
